import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { addNewScholarshipFunderOperation } from '../operations/add-new-scholarship-funder-operation';
import { EditText } from '../../../../../component/ui/edit-text/edit-text';

interface DialogAddNewScholarshipFunderProps {
  closeDialog: () => void;
}

export const DialogAddNewScholarshipFunder: React.FC<
  DialogAddNewScholarshipFunderProps
> = ({ closeDialog }) => {
  const [funderName, setFunderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    await addNewScholarshipFunderOperation(
      funderName,
      setIsLoading,
      closeDialog,
    );
  };

  return (
    <div>
      <div className="field">
        <EditText
          title={'גוף מממן'}
          id="funderName"
          onChange={(value) => setFunderName(value)}
          className="w-full"
        />
      </div>
      <div
        style={{
          marginTop: '1rem',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button label="ביטול" className="p-button-text" onClick={closeDialog} />
        <Button
          label="שמור"
          onClick={handleSubmit}
          loading={isLoading}
          disabled={!funderName.trim()}
        />
      </div>
    </div>
  );
};
